export default "__VITE_ASSET__CUtYZJx1__"